<div *ngIf="insurers.length>0">
  <div *ngFor="let insurer of insurers; let i = index">
    <div class="col-xs-12 col-md-6" id="textBox2">
      <h3 class="section-title">Datos del asegurado {{insurer.number}} </h3>
      <div class="form-control input">
        <p class="section-subtitle">Fecha de nacimiento</p>
        <label class="has-float-label date-input-text {{insurer.error}} placeholder-date">
          <input id="txtDate{{insurer.number}}" type="text" date-mask
                 [(ngModel)]="insurer.date" (ngModelChange)="submitAnswer(insurer,i)" placeholder="dd/mm/aaaa"
                 class="text-input inline text-09-d-demibold txtDate ">
        </label>
          <p id="Additional{{insurer.number}}" class="hidden error error-txt">Para continuar, introduce una fecha válida</p>
      </div>
    </div>
  </div>
</div>
